import { Screen } from '../contexts/AppContext';

export type TabPressNavigateTo = (screen: Screen, param?: string, routeParams?: Record<string, any>) => void;
export type TabPressSetActiveTab = (tabId: string) => void;

export interface CreateTabPressHandlerExtras {
  /** Called instead of navigating when the 'more' tab/button is pressed — most screens open a MoreOptionsModal locally. */
  onMore?: () => void;
}

/**
 * Single shared tab-press handler, replacing the same block of ~10 if/else
 * branches that used to be hand-copied into every screen (HomeScreen.tsx's
 * version was the most complete copy and is the basis for this one). Most
 * per-screen copies only covered a subset of tabs — missing branches meant
 * clicking a tab did nothing beyond setActiveTab, requiring a detour through
 * the logo/Home before the tab click would actually navigate anywhere.
 *
 * screenId values come from Header.tsx (desktop nav: home/contacts/calendar/
 * orders, with calendar already remapped to business-calendar before this is
 * called) and BottomTabs.tsx (mobile: home/contacts/calendar/orders/more,
 * same remap) — plus 'social'/'products'/'performance'/'chat' from other
 * entry points (e.g. the More modal) that reuse this same handler shape.
 */
export const createTabPressHandler = (
  navigateTo: TabPressNavigateTo,
  setActiveTab: TabPressSetActiveTab,
  extras?: CreateTabPressHandlerExtras
) => (screenId: string) => {
  const tabId = screenId === 'business-calendar' ? 'calendar' : screenId;
  setActiveTab(tabId);

  if (screenId === 'home') {
    navigateTo('home');
  } else if (screenId === 'chat') {
    navigateTo('chat');
  } else if (screenId === 'social') {
    navigateTo('social');
  } else if (screenId === 'contacts') {
    navigateTo('contacts');
  } else if (screenId === 'business-calendar') {
    navigateTo('business-calendar');
  } else if (screenId === 'orders') {
    navigateTo('orders');
  } else if (screenId === 'products') {
    navigateTo('products');
  } else if (screenId === 'performance') {
    navigateTo('performance');
  } else if (screenId === 'more') {
    extras?.onMore?.();
  }
};
